export enum TypeEnum {
  PROPERTY = 'PROPERTY',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  WEBPUSH = 'WEBPUSH',
  PUSH = 'PUSH',
  WHATSAPP = 'WHATSAPP',
  VIBER = 'VIBER',
  RCS = 'RCS',
  GOOGLE_RSA_SEARCH = "GOOGLE_RSA_SEARCH",
  GOOGLE_GEN_SINGLE_IMAGE = "GOOGLE_GEN_SINGLE_IMAGE",
  GOOGLE_GEN_VIDEO = "GOOGLE_GEN_VIDEO",
  GOOGLE_PERFORMANCE_MAX = "GOOGLE_PERFORMANCE_MAX",
  GOOGLE_YOUTUBE_VIDEO = "GOOGLE_YOUTUBE_VIDEO",
  META_SINGLE_IMAGE = "META_SINGLE_IMAGE",
  META_VIDEO = "META_VIDEO",
  META_CAROUSEL = "META_CAROUSEL"
}
